import SelectPageModal from "../../../../modals/SelectPageModal/SelectPageModal.js";
import CustomErrorWrapper from "./CustomErrorWrapper.js";

const SpecificPageField = ({ input, meta: { error } }) => {

  return (
    <div style={{ paddingLeft: "1.75rem" }}>
      <SelectPageModal input={input} />
      {error && <CustomErrorWrapper error={error} />}
    </div>
  );
};

export default SpecificPageField;